import React, { useState } from "react";
import { Typography } from "@mui/material";

import analytics from "fond/analytics";
import { LayerDeleteAction, LayerDrawAction } from "fond/project/panels/InputPanel/actions";
import LayerPanel from "fond/project/panels/InputPanel/LayerPanel";
import { ConfirmModal } from "fond/widgets";

import { useDesignEdits } from "../hooks/useDesignEdits";
import { useDesignRefinementActions } from "../hooks/useDesignRefinementActions";

/**
 * Stacked navigation panel for moving the hubs of a completed design.
 */
const HubsRefinementPanel: React.FC = () => {
  const { hasMovedHubs, hasDropAssignments } = useDesignEdits();
  const { moveHubs, deleteHubs } = useDesignRefinementActions();
  const [showConfirm, setShowConfirm] = useState(false);

  const onDraw = () => {
    analytics.track("Clicked move equipment");
    if (hasDropAssignments) {
      setShowConfirm(true);
    } else {
      moveHubs({ resetDropAssignments: false });
    }
  };

  const onConfirm = () => {
    moveHubs({ resetDropAssignments: true });
    setShowConfirm(false);
  };

  return (
    <>
      {showConfirm && (
        <ConfirmModal
          open
          content="Drop assignments must be reset to move hubs. Are you sure you want to reset your drop assignments?"
          onConfirm={onConfirm}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      <LayerPanel title="Hubs" layerKey="design-hubs">
        <LayerDrawAction subtitle="Move hubs on the map" onClick={onDraw} />
        {hasMovedHubs && (
          <LayerDeleteAction
            onDelete={deleteHubs}
            confirmContent={
              <Typography variant="body2">This will revert hubs to their generated locations. This action cannot be undone.</Typography>
            }
          />
        )}
      </LayerPanel>
    </>
  );
};

export default HubsRefinementPanel;
